// import _ from "lodash";
export const roundInSum = (l: number[], target: number) => {
    return l;

    // var off =
    //     target -
    //     _.reduce(
    //         l,
    //         function (acc, x) {
    //             return acc + Math.round(x);
    //         },
    //         0
    //     );
    // return _.chain(l)
    //     .sortBy(x => {
    //         return Math.round(x) - x;
    //     })
    //     .map((x, i) => {
    //         return Math.round(x) + (off > i) - (i >= l.length + off);
    //     })
    //     .value();
};
